module.exports = __webpack_public_path__ + "static/media/ss3.cbf5fada.jpg";